module.exports = __webpack_public_path__ + "img/H000120_rottoenapple.9f38f6bc.png";